module.exports = "https://web-assets.ifttt.com/packs/media/partners/pin-6548d05b.svg";